@if (show()) {
	<dialog #dialog (cancel)="escape($event)" [class]="animation()">
		<div class="content">
			<div class="scroller">
				<div class="scroller-content">
					<ng-content></ng-content>
				</div>
			</div>
		</div>
		@if (!mandatory()) {
			<div
				class="cross"
				role="button"
				tabindex="0"
				i18n-aria-label="@@common.close"
				aria-label="Close"
				(click)="close()"
				(keydown.enter)="close()"
				(keydown.space)="close(); $event.preventDefault()"
			>
				<div class="branch"></div>
				<div class="branch"></div>
			</div>
		}
	</dialog>
}
